// extracted by mini-css-extract-plugin
export default {"card":"Panel_card__VV0EC","cardHeader":"Panel_cardHeader__5HBkt","cardBody":"Panel_cardBody__DNONy"};